const SERVICE_GUIDE_PATH = 'service';
const ROLE_GUIDE_PATH = 'service/management/iam/roles';
const DOMAIN_ROLE_GUIDE_PATH = 'service/management/iam/roles/org-roles';
const PROJECT_ROLE_GUIDE_PATH = 'service/management/iam/roles/project-roles';
const IAM_MAIN_GUIDE_PATH_WITHOUT_BASE_PATH = 'management/iam/iam-main';
const IAM_MANAGE_PROJECT_GUIDE_PATH_WITHOUT_BASE_PATH =
  'management/iam/how-to-guides/iam-manage-project';

export const GUIDE_PATH = {
  SERVICE_GUIDE_PATH,
  ROLE_GUIDE_PATH,
  DOMAIN_ROLE_GUIDE_PATH,
  PROJECT_ROLE_GUIDE_PATH,
  IAM_MAIN_GUIDE_PATH_WITHOUT_BASE_PATH,
  IAM_MANAGE_PROJECT_GUIDE_PATH_WITHOUT_BASE_PATH,
};
